import {
  Check,
  ContentCopyOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';

import { getMaskedValue } from 'new/modules/settings/capsules/utils/capsuleHelpers';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/components/KeyRevealField/KeyRevealField.module.scss';

interface KeyRevealFieldProps {
  label: string;
  /** Right-aligned helper text (e.g. inside Access Credentials panel). */
  description?: string;
  value: string;
  isVisible: boolean;
  isCopied: boolean;
  onToggleVisibility: () => void;
  onCopy: () => void;
}

export function KeyRevealField(props: KeyRevealFieldProps) {
  const { label, description, value, isVisible, isCopied, onToggleVisibility, onCopy } = props;

  const displayedValue = isVisible ? value : getMaskedValue(value);
  const revealTooltip = isVisible ? 'Hide' : 'Reveal';
  const copyTooltip = isCopied ? 'Copied!' : 'Copy to clipboard';

  return (
    <div className={styles.field}>
      <div
        className={description ? styles.metaRow : `${styles.metaRow} ${styles.metaRowLabelOnly}`}
      >
        <Typography variant="body2" className={styles.label}>
          {label}
        </Typography>
        {description ? (
          <Typography variant="caption" className={styles.description}>
            {description}
          </Typography>
        ) : null}
      </div>

      <div className={styles.valueRow}>
        <Typography className={styles.valueText}>{displayedValue}</Typography>
        <div className={styles.actions}>
          <Tooltip title={revealTooltip}>
            <IconButton aria-label={revealTooltip} onClick={onToggleVisibility}>
              {isVisible ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
            </IconButton>
          </Tooltip>
          <Tooltip title={copyTooltip}>
            <IconButton aria-label="Copy to clipboard" onClick={onCopy}>
              {isCopied ? <Check /> : <ContentCopyOutlined />}
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
